/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const resolveEffectiveRegistration = ({ baseRegistration, overlayRegistration } = {}) => {
  const overlayActive = overlayRegistration && overlayRegistration.enabled !== false;

  if (overlayActive) {
    return overlayRegistration;
  }

  return baseRegistration ?? null;
};
